import React from 'react';
import { Row, Col } from 'react-bootstrap';
import cn from 'classnames';
import styles from './style.scss';

import NoEvents from '../no_events';

class TwitchPreviousVideo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      host: window.baseUrl ? new URL(window.baseUrl).hostname : '',
    };
  }

  render() {
    const { event, settings } = this.props;
    if (settings.get('twitchShowPreviousVideoForOffline') && event.has('previous_videos') && event.get('previous_videos').size > 0) {
      const params = `parent=client.geteventviewer.com&parent=editor.wix.com&parent=${this.state.host}`;

      const url = `https://player.twitch.tv/?video=v${event.getIn(['previous_videos', 0, 'id'])}&${params}&autoplay=true`;
      const isMobile = window.isMobileType;
      const offlineTextSection = isMobile ? 12 : 3;
      const offlineVideoSection = isMobile ? 12 : 9;
      return (
        <Row>
          <Col xs={offlineTextSection} className={cn('event', styles.twitchPreviousVideo, { [styles.twitchMobileContainer]: isMobile })}>
            <span className={cn('title', styles.offlineText)}>Offline</span>
            <div className="description">Check out this recent video.</div>
          </Col>
          <Col xs={offlineVideoSection}>
            <iframe frameBorder="0" src={url} title="Event Viewer" width="100%" height="400px" allowFullScreen="true" />
          </Col>
        </Row>
      );
    }
    return <NoEvents settings={settings} image={event.get('offline_image_url')} />;
  }
}

export default TwitchPreviousVideo;
